<script setup>
import {
  AlertCircle,
  Banknote,
  CreditCard,
  DollarSign,
  FileText,
  FileWarning,
  ShoppingCart,
  TrendingUp,
  Undo2,
  Wallet,
} from "lucide-vue-next";
import KpiCard from "./KpiCard.vue";
import { computed, onMounted } from "vue";
import { moneyFormat } from "@/utils/helpers";

const props = defineProps({
  stats: { type: Object, default: () => ({}) },
});

const kpis = computed(() => [
  {
    title: "Total de Estudantes Matriculados",
    value: props.stats?.incriptionAndEnroll?.total,
    description: "",
    icon: FileText,
  },
  {
    title: "Total de inscrições pendentes",
    value: props.stats?.totalInscritpionPending,
    description: "",
    icon: FileWarning,
  },
  {
    title: "Valor Total de Estudantes Matriculados",
    value: moneyFormat(props.stats?.incriptionAndEnroll?.total_amount),
    description: "",
    icon: FileText,
  },
  {
    title: "Total em Dívida",
    value: moneyFormat(props.stats?.totalDebts),
    description: "",
    icon: AlertCircle,
  },
  {
    title: "Total Pagamentos Efectuados",
    value: moneyFormat(props.stats?.totalReceived?.total_amount) ?? 0,
    description: "",
    icon: Wallet,
  },
  {
    title: "Total pago do mês",
    value: moneyFormat(props.stats?.PaidInMonth) ?? 0,
    description: props.stats?.PaidInMonth?.billingMonth,
    icon: Banknote,
  },
]);

onMounted(() => {
  console.log("====================================");
  console.log(props.stats);
  console.log("====================================");
});
</script>

<template>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 md:grid-cols-4 gap-3"
  >
    <template v-for="k in kpis" :key="k.title">
      <KpiCard
        :title="k.title"
        :value="k.value"
        :icon="k.icon"
        :trend="undefined"
        :description="k.description"
      />
    </template>
  </div>
</template>